import type { ReactNode } from "react";
import { useSystemHealth } from "@/features/system/hooks/useSystemHealth";
import MaintenancePage from "@/features/system/pages/MaintenancePage";
import { BusyIndicator } from "@/components/BusyIndicator";

export function MaintenanceGate({ children }: { children: ReactNode }) {
  const { phase, report, checkedAt, busy, recheck } = useSystemHealth();

  if (phase === "checking") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-muted px-4">
        <BusyIndicator label="Connecting…" className="max-w-xs" />
      </div>
    );
  }

  if (phase === "down") {
    return (
      <MaintenancePage
        report={report}
        checkedAt={checkedAt}
        busy={busy}
        onRetry={recheck}
      />
    );
  }

  return <>{children}</>;
}
